(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tempo-gasto', {
                parent: 'entity',
                url: '/tempo-gasto?page&sort&search&situacao&dia',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Tempo Gasto'
                },
                ncyBreadcrumb: {
                    label: 'Tempo Gasto'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tempogasto/tempogasto.html',
                        controller: 'TempoGastoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    dia: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            dia: $stateParams.dia
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('tipoHora');

                        return $translate.refresh();
                    }]
                }
            })
            .state('tempo-gasto.new', {
                parent: 'entity',
                url: 'tempo-gasto/new',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tempogasto/tempogasto-dialog.html',
                        controller: 'TempoGastoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {chamado: null, criadoEm: new Date(), horas: 0, minutos: 0};
                            }
                        }
                    }).result.then(function (result) {
                        $state.go('^');
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
        ;
    }
})();
